module.exports = __webpack_public_path__ + "img/2.e77940cb.jpg";;
if (typeof window !== 'undefined') {
(window.__IMAGE_SIZES__ || (window.__IMAGE_SIZES__ = {}))[module.exports] = {"width":1386,"height":806,"variants":[{"file":"img/2-480w.f5f7972bd807.webp","width":480},{"file":"img/2-960w.977f505e69c9.webp","width":960},{"file":"img/2-1386w.677ca8607487.webp","width":1386}]};
}